import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPointV2, AdminNavEntryPointV3 } from '@retailer-platform/dashboard/routing'
import { partnerManagementAdminRouter } from './routing/partnerManagementAdminRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { partnerManagementAdminAccessControl } from './access-control/partnerManagementAdminAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'partner-management',
  totem: {
    tool: 'partner-management-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  routers: {
    admin: [partnerManagementAdminRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [
    {
      attachToV2: AdminNavEntryPointV2.Operations,
      attachToV3: AdminNavEntryPointV3.PartnerSettings,
      subNavItems: [
        {
          route: 'app-admin-partner-management-list',
          labelId: 'partnerManagementDomain.listPage.title',
          accessControl: partnerManagementAdminAccessControl,
        },
      ],
    },
  ],
}

export default definition
